import { render, staticRenderFns } from "./custom-components.datatable.vue?vue&type=template&id=8a481fa6&scoped=true&"
import script from "./custom-components.datatable.vue?vue&type=script&lang=js&"
export * from "./custom-components.datatable.vue?vue&type=script&lang=js&"
import style0 from "./custom-components.datatable.vue?vue&type=style&index=0&id=8a481fa6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a481fa6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
